import { isNil } from 'lodash';

import { CallListCommunicationWorkflowConfig } from '@pwp-common';

import { CommunicationWorkflowConfigEditorOutput } from '../communication-workflow-config-editor-output';

export const dbToCommunicationWorkflowConfigEditorOutput = (
  communicationWorkflowConfig: CallListCommunicationWorkflowConfig | undefined,
): CommunicationWorkflowConfigEditorOutput | undefined => {
  if (isNil(communicationWorkflowConfig)) {
    return undefined;
  }

  return {
    communicationWorkflowId: communicationWorkflowConfig.getCommunicationWorkflowId(),
  };
};
